// src/components/sections/NewsletterSection.jsx
import React from "react";
import HeadingWithWatermark from "../HeadingWithWatermark";
import HorizontalScroller from "../HorizontalScroller";

const NewsletterSection = () => {
  const scrollerItems = [
    {
      image: "/img/June report.png",
      title: "Digital Transformation for Small Businesses",
      file: "/pdfs/june.pdf",
    },
    {
      image: "/img/July_newsletter.png",
      title: "AI & Automation for Enterprises",
      file: "/pdfs/july.pdf",
    },

    {
      image: "/img/Oct_newsletter.png",
      title: "FICCI–EY Innovation Report",
      file: "/pdfs/oct.pdf",
    },
    {
      image: "/img/Nov_newsletter.png",
      title: "Global AI Race",
      file: "/pdfs/nov.pdf",
    },
  ];

  return (
    <section className="py-10 md:py-14 bg-white overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        
        {/* Heading */}
        <HeadingWithWatermark
          title="Newsletter"
          watermarkText="WASME"
          color="#1b73a7"
          align="center"
        />

        {/* Scroller */}
        <HorizontalScroller
          items={scrollerItems}

          /** Behavior control */
          autoScroll={true}
          speed={1.2}
          direction="left"
          draggable={true}
          pauseOnHover={true}

          /** UI control */
          showFade={true}
          gap="gap-10"
        />
      </div>
    </section>
  );
};

export default NewsletterSection;
